module.exports = __webpack_public_path__ + "static/media/info--info.939f9423.svg";